import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Lock, Trash2 } from "lucide-react";
import { api, fmtDate, publicLinkUrl } from "@/lib/api";
import { useFiles } from "@/context/FilesContext";
import { Button } from "@/components/ui/button";

export default function Links() {
  const [links, setLinks] = useState([]);
  const { openFile } = useFiles();
  const load = () => api.get("/links").then((r) => setLinks(r.data));
  useEffect(() => { load(); }, []);
  const status = (l) => (l.revoked ? ["Révoqué", "bg-slate-100 text-slate-600"] : new Date(l.expires_at) < new Date() ? ["Expiré", "bg-red-50 text-red-700"] : ["Actif", "bg-emerald-50 text-emerald-700"]);

  return (
    <div className="max-w-5xl mx-auto fade-up" data-testid="links-page">
      <p className="text-xs uppercase tracking-wider font-semibold text-slate-500">Partage externe</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-1 mb-6">Liens de partage</h1>
      {links.length === 0 && <div className="border border-dashed rounded-xl py-16 text-center text-sm text-slate-500">Aucun lien. Créez-en un depuis l'onglet « Partage » d'un document.</div>}
      <div className="bg-white border rounded-xl divide-y">
        {links.map((l) => {
          const [label, cls] = status(l);
          return (
            <div key={l.id} className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 px-4 py-3" data-testid={`link-row-${l.id}`}>
              <button className="flex-1 min-w-0 text-left" onClick={() => openFile(l.file_id)}>
                <div className="text-sm font-medium truncate flex items-center gap-2">{l.file_name}{l.has_password && <Lock className="h-3.5 w-3.5 text-slate-400" />}</div>
                <div className="text-xs text-slate-500">Créé le {fmtDate(l.created_at)} par {l.created_by_name} · expire le {fmtDate(l.expires_at, true)} · {l.access_count} accès</div>
              </button>
              <div className="flex items-center gap-2">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded ${cls}`}>{label}</span>
                {label === "Actif" && <>
                  <Button variant="ghost" size="icon" aria-label="Copier le lien" onClick={() => { navigator.clipboard?.writeText(publicLinkUrl(l.token)); toast.success("Lien copié"); }} data-testid={`links-copy-${l.id}`}><Copy className="h-4 w-4" /></Button>
                  <Button variant="ghost" size="icon" aria-label="Révoquer" onClick={async () => { await api.delete(`/links/${l.id}`); toast.success("Lien révoqué"); load(); }} data-testid={`links-revoke-${l.id}`}><Trash2 className="h-4 w-4" /></Button>
                </>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
